import React, { useEffect } from "react"
import Box from "@material-ui/core/Box"
import Dialog from "@material-ui/core/Dialog"

import PropTypes from "prop-types"
import { Form } from "react-final-form"
import { setPage, setSearch } from "src/features/Utils/mutators"
import { useSelector, useDispatch } from "react-redux"
import Search from "./Search"
import MedicineItem from "./MedicineItem"
import ShowTotal from "./ShowTotal"
import Paging from "./Pagination"
import { fetchList as fetchListMedicine } from "src/pages/Medicine/ducks"
import { selectMedicineBundle, updateMedicineBundle } from "../../ducks"
import useNotification from "src/features/Notification/customs"

const initialValues = {
  search_name: "",
  page: 1,
  limit: 5,
  // store searched fields in order to handle paging
  searched: {
    search_name: "",
  },
}

function MyDialog({ isOpen, handleClose }) {
  const dispatch = useDispatch()
  const { showSuccess } = useNotification()
  // medicine
  const fetchingMedicine = useSelector((state) => state.medicine.fetching)
  const totalMedicine = useSelector((state) => state.medicine.total)
  const listMedicine = useSelector((state) => state.medicine.list)

  const bundle_medicines = useSelector(
    (state) => state.bundle_create.bundle_medicines
  )

  const handleFetchList = (values = initialValues) => {
    dispatch(fetchListMedicine(values))
  }

  // eslint-disable-next-line
  useEffect(() => {
    handleFetchList()
    // eslint-disable-next-line
  }, [])

  const inCart = (_id) => bundle_medicines.find((item) => item._id === _id)
  // find index
  const findIndex = (_id) =>
    bundle_medicines.map((item) => item._id).indexOf(_id)

  const handleAddMedicine = (item) => (amount) => {
    dispatch(selectMedicineBundle({ ...item, amount }))
    showSuccess()
    handleClose()
  }
  const handleUpdateMedicine = (_id) => (amount) => {
    dispatch(updateMedicineBundle(findIndex(_id, "medicine"), amount))
    showSuccess()
    handleClose()
  }

  return (
    <Form
      initialValues={initialValues}
      onSubmit={({ searched, page, limit, ...values }, { mutators }) => {
        // values will be set in 'searched'
        mutators.setSearch(values)
        // reset page when search
        mutators.setPage(1)
        handleFetchList({ ...values, limit, page: 1 })
      }}
      mutators={{ setPage, setSearch }}
      subscription={{ submitting: true }}
    >
      {({ handleSubmit }) => (
        <Dialog open={isOpen} maxWidth="lg" onClose={handleClose} fullWidth>
          <Box bgcolor="#191C3A" pt={3} pb={4} pl={7}>
            <Box fontSize="25px" color="#FFFFFFDE">
              Package of Medicine
            </Box>
            <form onSubmit={handleSubmit}>
              <Search />
            </form>
          </Box>
          <Box pb={3} pl={7} pr={7}>
            <ShowTotal
              total={totalMedicine}
              fetching={fetchingMedicine}
              handleFetchList={handleFetchList}
            />
            <Box overflow="auto" whiteSpace="nowrap">
              <Box minWidth="700px">
                <Box mt={2} minWidth="1184px">
                  {listMedicine.map((item, index) => (
                    <MedicineItem
                      key={item._id}
                      item={item}
                      action={
                        !!inCart(item._id, "medicine")
                          ? handleUpdateMedicine(item._id)
                          : handleAddMedicine(item)
                      }
                      inCart={inCart(item._id, "medicine")}
                    />
                  ))}
                </Box>
              </Box>
            </Box>
            <Paging total={totalMedicine} onFetch={handleFetchList} />
          </Box>
        </Dialog>
      )}
    </Form>
  )
}

MyDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
}

export default MyDialog
